import {
	Button,
	CircularProgress,
	Grid,
	Snackbar,
	Typography,
} from "@material-ui/core";

import { ErrorModal } from "@/components/shared/modal/error-modal";
import Modal from "@/components/shared/modal/modal";
import { ComponentType } from "@/pages/configurations/componentTypes/models/ComponentType";
import {
	deleteComponentType,
	getComponentTypeById,
} from "@/pages/configurations/componentTypes/repositories/ComponentTypes";
import { Alert, Color } from "@material-ui/lab";
import React, { useEffect, useState } from "react";

type Props = {
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
	componentTypeIdForDelete: number | null;
};

export const DeleteComponentType = ({
	show,
	onHide,
	componentTypeIdForDelete,
}: Props) => {
	const [openAlertMessage, setOpenAlertMessage] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [message, setMessage] = useState("");
	const [messageType, setMessageType] = useState<Color | undefined>(undefined);

	const [componentTypeForDelete, setComponentTypeForDelete] =
		useState<ComponentType | null>(null);

	const [error, setError] = useState<string | null>(null);

	const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}
		setOpenAlertMessage(false);
	};

	const handleDelete = async () => {
		setIsSubmitLoading(true);
		try {
			const res = await deleteComponentType(componentTypeIdForDelete);
			if (res.ok) {
				setMessage(" The Component Type was deleted successfully");
				setMessageType("success");
				onHide(true);
				setComponentTypeForDelete(null);
			}
		} catch (e) {
			setMessage("Error, please try again");
			setMessageType("error");
			setError(e as string);
		}
		setIsSubmitLoading(false);
		setOpenAlertMessage(true);
	};

	useEffect(() => {
		if (show) {
			(async () => {
				setIsLoading(true);
				const { componentType } = await getComponentTypeById(
					componentTypeIdForDelete,
				);
				if (componentType?.success) {
					setComponentTypeForDelete(componentType.result);
				} else {
					onHide(true);
					setMessage("Error, component type not found. Try again");
					setOpenAlertMessage(true);
					setComponentTypeForDelete(null);
				}

				setIsLoading(false);
			})();
		}
	}, [show]);

	return (
		<>
			<>
				<Modal
					open={show}
					handleClose={() => {
						onHide(true);
					}}
					id="deleteComponentType"
					title={"Delete a component type"}
					maxWidth="sm"
				>
					<Modal.Content>
						{isLoading && (
							<Grid
								container
								justifyContent="center"
								alignItems="center"
								style={{ minHeight: "60px" }}
							>
								{/* <LazyLoading /> */}
								<CircularProgress size="3rem" />
							</Grid>
						)}

						{!isLoading && (
							<>
								<Grid container spacing={1}>
									<Typography>
										You will not be able to recover deleted data
									</Typography>
								</Grid>
								<br />
								<Grid container spacing={1}>
									<Typography>
										Are you sure you want to delete{" "}
										<strong>{componentTypeForDelete?.componentTypeName}</strong>
										?
									</Typography>
								</Grid>
							</>
						)}
					</Modal.Content>
					<Modal.Actions style={{ padding: "20px 30px 30px" }}>
						<Grid container spacing={2} justifyContent="flex-end">
							<Grid item md={3} xs={12} style={{ margin: 0 }}>
								<Button
									fullWidth
									variant="contained"
									color="default"
									onClick={() => {
										onHide(false);
										setComponentTypeForDelete(null);
									}}
								>
									Cancel
								</Button>
							</Grid>
							<Grid item md={3} xs={12} style={{ margin: 0 }}>
								<Button
									fullWidth
									startIcon={
										isSubmitLoading ? <CircularProgress size="1rem" /> : <></>
									}
									disabled={isSubmitLoading}
									variant="contained"
									color="secondary"
									onClick={handleDelete}
								>
									Delete
								</Button>
							</Grid>
						</Grid>
					</Modal.Actions>
				</Modal>

				<Snackbar
					open={openAlertMessage}
					autoHideDuration={2500}
					onClose={handleClose}
				>
					<Alert severity={messageType} onClose={handleClose}>
						{message}
					</Alert>
				</Snackbar>
			</>
			<ErrorModal onHide={() => setError(null)} error={error} />
		</>
	);
};
